import { defineStore } from "pinia";
import api from "@/services/api";
import IItemImage from "@/models/responses/IItemImage";
import ItemImage from "@/models/frontend/ItemImage";
import { useTenantsStore, useItemsStore } from "@/stores";

export const useItemImagesStore = defineStore("itemImages", {
  state: () => ({
    error: "" as any,
  }),
  actions: {
    async loadItemImageByType(itemId: number, imageTypeCode: string) {
      this.error = "";
      let itemImage: ItemImage | undefined;

      await api
        .get<IItemImage>(`v1.0/items/${itemId}/images/${imageTypeCode}`)
        .then((response) => (itemImage = this.mapToFrontend(response.data)))
        .catch((error) => (this.error = error));

      return itemImage;
    },
    async loadItemImageAsZplByType(itemId: number, imageTypeCode: string, length: number, width: number) {
      this.error = "";
      let itemImage: string | undefined;

      await api
        .get<string | undefined>(`v1.0/items/${itemId}/zpls/${imageTypeCode}`,
          {
            params: {
              length: length,
              width: width
            }
          })
        .then((response) => (itemImage = response.data))
        .catch((error) => (this.error = error));

      return itemImage;
    },
    async saveItemImage(itemId: number, imageTypeCode: string, file: File) {
      const formData = new FormData();
      formData.append('file', file);

      await api.post(`v1.0/items/${itemId}/images/${imageTypeCode}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    },
    async deleteItemImage(id: number) {
      await api.delete(`v1.0/item-images/${id}`);
    },
    mapToFrontend(itemImage: IItemImage) {
      const tenant = useTenantsStore().getById(itemImage.tenantId);
      const item = useItemsStore().getById(itemImage.itemId);
      return new ItemImage(
        itemImage.id,
        tenant,
        item,
        itemImage.imageTypeCode,
        itemImage.imageDataType,
        itemImage.binaryContent,
      );
    }
  },
});
